import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f8dda67e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f8dda67e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8dda67e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8dda67e')) {
      api.createRecord('f8dda67e', component.options)
    } else {
      api.reload('f8dda67e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f8dda67e&scoped=true", function () {
      api.rerender('f8dda67e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimsManagement/claimStatement/index.vue"
export default component.exports